import PropTypes from 'prop-types'
import React, { Component } from 'react'
import FriendsHeader from './FriendsHeader'
import { push } from 'react-router-redux'
import { connect } from 'react-redux'
import * as friendActions from 'services/friends/actions'
import * as site from 'services/site/selectors'
import { Row, Col } from 'react-flexbox-grid'
import styles from './_friendGlobal.css'
import inviteStyles from './_inviteFriends.css'
import Svg from 'components/util/Svg'

const mapStateToProps = (state) => ({
  siteName: site.selectSiteName(state),
  siteAuthUrl: site.selectSiteAuthUrl(state),
})

const mapDispatchToActions = {
  ...friendActions,
  push,
}

export class InviteFriends extends Component {
  static propTypes = {
    inviteFacebookFriends: PropTypes.func,
    siteName: PropTypes.string,
    siteAuthUrl: PropTypes.string,
  };

  handleFacebookInvite = () => {
    const { siteAuthUrl } = this.props
    this.props.inviteFacebookFriends(siteAuthUrl)
  }

  handleTwitterInvite = (e) => {
    e.preventDefault()
    const { siteAuthUrl, siteName } = this.props
    const twitterUrl = 'https://twitter.com/intent/tweet'
    const twitterPostText = `Fitness+is+more+fun+with+friends+-+join+me+on+${siteName}%3F`
    window.open(
      `${twitterUrl}?url=${siteAuthUrl}&text=${twitterPostText}`,
      'tweet_window',
      'height=450,width=600'
    )
  }

  render () {
    return (
      <div className={styles.friendPageContainer}>
        <FriendsHeader />
        <Row>
          <Col xs={12} md={6}>
            <div className={styles.friendContainer}>
              <div className={styles.friendInner}>
                <Svg name='facebook' className={inviteStyles.iconFacebook} />
                <div>
                  <div className={inviteStyles.title}>Facebook</div>
                  <a href='#' onClick={this.handleFacebookInvite}>Invite Friends</a>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className={styles.friendContainer}>
              <div className={styles.friendInner}>
                <Svg name='twitter' className={inviteStyles.iconTwitter} />
                <div>
                  <div className={inviteStyles.title}>Twitter</div>
                  <a href='#' onClick={this.handleTwitterInvite}>Invite Friends</a>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(InviteFriends)



// WEBPACK FOOTER //
// ./src/components/friends/InviteFriends.jsx